module.exports = __webpack_public_path__ + "26d92cdaff7f7daaf67d9f53eced3d17.svg";